import React from 'react';
import { Row, Col, Divider, Tag, Typography } from 'antd';
import moment from 'moment';
import ModernFormModal from './ModernFormModal';
import type { Vendor } from '../services/masterDataService';

const { Text } = Typography;

interface VendorDetailsModalProps {
  open: boolean;
  vendor: Vendor;
  onClose: () => void;
}

const VendorDetailsModal: React.FC<VendorDetailsModalProps> = ({ open, vendor, onClose }) => {
  const email = vendor.email || vendor.contact_email;
  const phone = vendor.phone || vendor.contact_phone;

  return (
    <ModernFormModal
      open={open}
      onClose={onClose}
      title={`Vendor Details — ${vendor.code}`}
      subtitle="View vendor contact and account information."
      headerVariant="light"
      headerSummary={
        <>
          <div>
            <span className="mf-summary-label">Code:</span>{' '}
            <span className="mf-summary-value">{vendor.code}</span>
          </div>
          <div>
            <span className="mf-summary-label">Name:</span>{' '}
            <span className="mf-summary-value">{vendor.name}</span>
          </div>
          <div>
            <span className="mf-summary-label">Status:</span>{' '}
            <Tag color={vendor.is_active ? 'success' : 'default'}>
              {vendor.is_active ? 'Active' : 'Inactive'}
            </Tag>
          </div>
          <div>
            <span className="mf-summary-label">Payment terms:</span>{' '}
            <span className="mf-summary-value">{vendor.payment_terms ?? 30} days</span>
          </div>
        </>
      }
      getContainer={() => document.querySelector('.main-content-full') as HTMLElement || document.body}
      wrapClassName="form-panel-full-wrap"
      width="100%"
      style={{ maxWidth: 'none' }}
      bodyStyle={{ padding: 0 }}
      cancelText="Close"
      showOkButton={false}
      destroyOnClose
    >
      <div style={{ padding: 24, width: '100%', boxSizing: 'border-box' }}>
        <Row gutter={16}>
          <Col span={12}>
            <p style={{ fontSize: '12px', fontWeight: 400 }}>
              <span style={{ fontWeight: 400 }}>Code:</span> {vendor.code}
            </p>
            <p style={{ fontSize: '12px', fontWeight: 400 }}>
              <span style={{ fontWeight: 400 }}>Vendor name:</span> {vendor.name}
            </p>
            <p style={{ fontSize: '12px', fontWeight: 400 }}>
              <span style={{ fontWeight: 400 }}>Contact person:</span> {vendor.contact_person || '—'}
            </p>
          </Col>
          <Col span={12}>
            <p style={{ fontSize: '12px', fontWeight: 400 }}>
              <span style={{ fontWeight: 400 }}>Email:</span> {email || '—'}
            </p>
            <p style={{ fontSize: '12px', fontWeight: 400 }}>
              <span style={{ fontWeight: 400 }}>Phone:</span> {phone || '—'}
            </p>
            <p style={{ fontSize: '12px', fontWeight: 400 }}>
              <span style={{ fontWeight: 400 }}>Payment terms:</span> {vendor.payment_terms ?? 30} days
            </p>
            <p style={{ fontSize: '12px', fontWeight: 400 }}>
              <span style={{ fontWeight: 400 }}>Status:</span>{' '}
              <Tag color={vendor.is_active ? 'success' : 'default'}>{vendor.is_active ? 'Active' : 'Inactive'}</Tag>
            </p>
          </Col>
        </Row>

        {vendor.address ? (
          <>
            <Divider />
            <p style={{ fontSize: '12px', fontWeight: 400 }}>
              <span style={{ fontWeight: 400 }}>Address:</span>
            </p>
            <Text style={{ fontSize: '12px', whiteSpace: 'pre-wrap' }}>{vendor.address}</Text>
          </>
        ) : null}

        {(vendor.created_at || vendor.updated_at) && (
          <>
            <Divider />
            <Text type="secondary" style={{ fontSize: '12px' }}>
              {vendor.created_at && (
                <>Created {moment(vendor.created_at).format('DD MMM YYYY, HH:mm')}</>
              )}
              {vendor.created_at && vendor.updated_at && ' · '}
              {vendor.updated_at && (
                <>Updated {moment(vendor.updated_at).format('DD MMM YYYY, HH:mm')}</>
              )}
            </Text>
          </>
        )}
      </div>
    </ModernFormModal>
  );
};

export default VendorDetailsModal;
